import axios from "axios";

import { onRequestInterceptor } from "../interceptors/Auth";

const api = axios.create({});

api.interceptors.request.use(onRequestInterceptor);

export default api;
